<template>
	<div id="mobileEntranceAd">
		<ins class="kakao_ad_area" style="display:none;width:100%;vertical-align:top"
				 :data-ad-unit="adUnit"
				 data-ad-media="320"
				 data-ad-pubuser="1v8"
				 data-ad-type="A"
				 data-ad-width="320"
				 data-ad-height="100"
				 :data-ad-param-cp="grpid"
				 data-ad-param-channel="cafe"
		></ins>
	</div>
</template>

<script>
export default {
	props: ['grpid', 'adUnit'] // grpid 는 cp값이 필요 없어지면 삭제
}
</script>
